import { useCookieStore } from "@/store/cookie";
import { useMemo } from "react";

type CookieFooterNoticeProps = {
  variant?: "inline" | "bar";
};

export const CookieFooterNotice: React.FC<CookieFooterNoticeProps> = ({ variant = "bar" }) => {
  const hasConsented = useCookieStore((state) => state.hasConsented);
  const isAcceptAllModalOpen = useCookieStore((state) => state.isAcceptAllModalOpen);
  const isSelectionModalOpen = useCookieStore((state) => state.isSelectionModalOpen);
  const getCookieOptions = useCookieStore((state) => state.getCookieOptions);
  const options = useMemo(() => getCookieOptions(), [getCookieOptions]);
  const setIsSelectionModalOpen = useCookieStore((state) => state.setIsSelectionModalOpen);
  const setCookiePreferences = useCookieStore((state) => state.setCookiePreferences);
  const markConsentGiven = useCookieStore((state) => state.markConsentGiven);

  if (hasConsented || isAcceptAllModalOpen || isSelectionModalOpen) {
    return null;
  }

  const handleAcceptAll = () => {
    setCookiePreferences(options.map(({ value }) => value));
    markConsentGiven();
  };

  const handleManage = () => {
    setIsSelectionModalOpen(true);
  };

  if (variant === "inline") {
    return (
      <span className="subtext-x-small flex flex-wrap items-center gap-x-2 gap-y-1 text-secondary-foreground">
        <span>We use cookies to improve your experience.</span>
        <button
          type="button"
          className="cursor-pointer underline hover:text-foreground"
          onClick={handleAcceptAll}
        >
          Accept all
        </button>
        <span aria-hidden="true">·</span>
        <button
          type="button"
          className="cursor-pointer underline hover:text-foreground"
          onClick={handleManage}
        >
          Manage
        </button>
      </span>
    );
  }

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-muted/80 px-4 py-2 backdrop-blur-sm"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-2 gap-y-1">
        <p className="subtext-x-small text-muted-foreground">
          We use cookies to improve your experience.
        </p>
        <button
          type="button"
          className="subtext-x-small cursor-pointer underline hover:text-foreground"
          onClick={handleAcceptAll}
        >
          Accept all
        </button>
        <span aria-hidden="true" className="subtext-x-small text-muted-foreground">
          ·
        </span>
        <button
          type="button"
          className="subtext-x-small cursor-pointer underline hover:text-foreground"
          onClick={handleManage}
        >
          Manage cookies
        </button>
      </div>
    </div>
  );
};
